<script setup>
defineProps({
  ranking: {
    type: Array,
    required: false,
    default: () => [],
  },
  type: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: false,
    default: '#A7E3EA',
  },
  min: {
    type: String,
    required: false,
    default: null,
  },
  max: {
    type: String,
    required: false,
    default: null,
  },
  iconSource: {
    type: String,
    required: true,
  },
})

const activeRow = ref(-1)

function setActiveRow(row) {
  if (row === activeRow.value) activeRow.value = -1
  else {
    activeRow.value = row
  }
}
</script>

<template>
  <div>
    <ul>
      <li class="flex flex-col items-center p-6 text-base">
        <div class="flex items-center justify-center">
          <img class="mb-6" :src="iconSource" />
        </div>

        <div
          v-if="type === 'denkniveau' && min && max"
          class="flex-grow flex-col items-center p-2 text-base"
        >
          <p class="mb-4 text-center text-lg text-gray-800">
            We zijn op zoek naar
            <span v-if="min !== max">{{ `${min} tot ${max}` }}</span>
            <span v-else>{{ min }}</span>
            denkniveau
          </p>
        </div>

        <div class="w-full justify-start">
          <Accordion
            v-for="(item, index) in ranking"
            :key="index"
            :index="0"
            :is-open="index === activeRow"
            :is-last="index === ranking.length - 1"
            size="sm"
            @toggle="setActiveRow(index)"
          >
            <template #title>
              <div class="flex items-center">
                <div class="grow">
                  {{ item.label }}
                </div>
              </div>
            </template>
            <template #content> {{ item.description }} </template>
          </Accordion>
        </div>
      </li>
    </ul>
  </div>
</template>
